export const PHONE_DISPLAY = "0507359999";
export const PHONE_TEL = "tel:+966507359999";
export const WA_BASE = "https://wa.me/966507359999";

export function waLink(message) {
  return `${WA_BASE}?text=${encodeURIComponent(message)}`;
}

export function openWa(message) {
  window.open(waLink(message || "السلام عليكم، أرغب في الاستفسار عن خدمات ميرو للإطارات وخدمات السيارات."), "_blank", "noopener");
}
